import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { IModelBase } from 'common-components'
import { ODataService } from 'common-services'

export interface IProviderCoverage extends IModelBase {
  ProviderId: number
  PayerId: number
  PlanIds: number[]
  EpisodeTypeIds: number[]
  StartDate: Date
  EndDate?: Date
}

@Injectable()
export class ProviderCoveragesODataService extends ODataService<IProviderCoverage> {
  constructor(protected http: HttpClient, protected config: SmODataConfiguration) {
    super(http, config)
    this.typeName = 'ProviderCoverages'
  }
}
